<div class="dashboard-content">
  <div class="dashboard-content-text">
    Zenity is the first agent-centric security and governance platform that gives security teams control over how AI
    agents are developed, used, and behave across environments.
  </div>
  <div class="dashboard-content-cards">
    @if (permissionsService.isAdmin()) {
      <app-dashboard-card
        displayTitle="dashboardNewOrgPage.gettingStarted"
        logoPath="assets/images/menu-icons/integrations.svg"
        [withRedirect]="false"
        redirectText="Add Integration"
        (cardClick)="addIntegrationClicked()"
      >
      </app-dashboard-card>
    }
    <app-dashboard-card
      displayTitle="dashboardNewOrgPage.blog"
      logoPath="assets/images/dashboards-icons/browser.svg"
      [withRedirect]="true"
      href="https://zenity.io/blog/"
      redirectText="Zenity blog"
    >
    </app-dashboard-card>
  </div>
  <div class="dashboard-content-cards">
    <app-dashboard-card
      displayTitle="dashboardNewOrgPage.platforms"
      logoPath="assets/images/dashboards-icons/book.svg"
      [withRedirect]="true"
      href="https://zenity.io/glossary"
      redirectText="Zenity glossary"
    >
    </app-dashboard-card>
    <app-dashboard-card
      displayTitle="dashboardNewOrgPage.contactUs"
      logoPath="assets/images/dashboards-icons/contact-us.svg"
      [withRedirect]="true"
      href="mailto:support@zenity.io"
      redirectText="Contact us"
    >
    </app-dashboard-card>
  </div>
</div>
